/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * プレスリリースGIFアニメーションアップロード成功時のレスポンスデータ
 * @export
 * @interface PostPressReleaseGifAnimationSuccessResponseData
 */
export interface PostPressReleaseGifAnimationSuccessResponseData {
    /**
     * サーバーに保存されたファイルの名前
     * @type {string}
     * @memberof PostPressReleaseGifAnimationSuccessResponseData
     */
    fileName: string;
}

export function PostPressReleaseGifAnimationSuccessResponseDataFromJSON(json: any): PostPressReleaseGifAnimationSuccessResponseData {
    return PostPressReleaseGifAnimationSuccessResponseDataFromJSONTyped(json, false);
}

export function PostPressReleaseGifAnimationSuccessResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPressReleaseGifAnimationSuccessResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileName': json['file_name'],
    };
}

export function PostPressReleaseGifAnimationSuccessResponseDataToJSON(value?: PostPressReleaseGifAnimationSuccessResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file_name': value.fileName,
    };
}

